import { createContext, useContext, useState, ReactNode } from "react";

type Task = {
  id: string;
  label: string;
  status?: string;
  owner?: string;
};

type LapTaskContextType = {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
  currentTask: Task | null;
  setCurrentTask: (task: Task | null) => void;
  remark: string;
  loanDetails: any;
  setLoanDetails: (value: any) => void;
  uploadedFiles: UploadedFile[];
  addFile: (file: UploadedFile) => void;
  setRemark: (value: string) => void;
  removeFile: (name: string) => void;
  token: string;
  setToken: (value: string) => void;
  pageName: string;
  setPageName: (value: string) => void;
  loanApplicationID: string;
  setLoanApplicationID: (value: string) => void;
  taskList: any;
  setTaskList: (value: any) => void;
  selectedTask: any;
  setSelectedTask: (value: any) => void;
  tabData: any;
  setTabData: (value: any) => void;
};

interface UploadedFile {
  name: string;
  type: string;
  size: number;
  url: string;
}

const LapTaskContext = createContext<LapTaskContextType | undefined>(undefined);

export const useLapTask = () => {
  const context = useContext(LapTaskContext);

  if (!context) {
    throw new Error("useLapTask must be used within a LapTaskProvider");
  }
  return context;
};

export const LapTaskProvider = ({ children }: { children: ReactNode }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [currentTask, setCurrentTask] = useState<Task | null>(null);
  const [remark, setRemark] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [loanDetails, setLoanDetails] = useState<any>(null);
  const [pageName, setPageName] = useState<string>("");
  const [token, setToken] = useState<string>("");
  const [loanApplicationID, setLoanApplicationID] = useState<string>("");
  const [taskList, setTaskList] = useState<any>([]);
  const [selectedTask, setSelectedTask] = useState<any>(null);
  const [tabData, setTabData] = useState<any>({});

  const addFile = (file: UploadedFile) =>
    setUploadedFiles((prev) => [...prev, file]);

  const removeFile = (name: string) =>
    setUploadedFiles((prev) => prev.filter((file) => file.name !== name));

  return (
    <LapTaskContext.Provider
      value={{
        collapsed,
        setCollapsed,
        currentTask,
        setCurrentTask,
        token,
        setToken,
        pageName,
        setPageName,
        loanDetails,
        setLoanDetails,
        remark,
        setRemark,
        uploadedFiles,
        addFile,
        removeFile,
        loanApplicationID,
        setLoanApplicationID,
        taskList,
        setTaskList,
        selectedTask,
        setSelectedTask,
        tabData,
        setTabData,
      }}
    >
      {children}
    </LapTaskContext.Provider>
  );
};
